import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CustomStepDefinition, Options as SliderOptions } from '@angular-slider/ngx-slider';
import { SideBarService } from 'src/app/services/side-bar.service';
import { FilterMode, FilterProperty, ListFilterService, PropertyFilterComponent, Option, DateDataBag, DateFilterMode, FilterPropertyChanged } from '../list-filter-service';
import { distinctDates, getValue, iterableMap, newId } from 'src/app/services/utils';
import { DatePipe } from '@angular/common';
import { EventBrokerService } from 'src/app/services/event-broker.service';
import { Subscription } from 'rxjs';


const visibleOptionCount = 5;

declare module '@angular-slider/ngx-slider' {
  export interface CustomStepDefinition {
    description?: string;
    fromDate?: Date;
    toDate?: Date;
  }
}

@Component({
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html'
})
export class DateFilterComponent implements PropertyFilterComponent, OnInit, OnDestroy {
  allOptionCount: number;
  private propertyPath : string[];
  private items: any[];
  private minDate: Date;
  private maxDate: Date;
  private isThereEmptyDates = false;

  @Input()
  mode: 'List' | 'Search' = 'List';

  private _property: FilterProperty;
  get property(): FilterProperty {
    return this._property;
  }
  @Input()
  set property(value: FilterProperty) {
    if (value === this._property) return;
    this._property = value;
    this.propertyPath = value && value.Path && value.Path.split('.');
    this.load();
  }

  private _filterMode: FilterMode;
  get filterMode(): FilterMode {
    return this._filterMode;
  }
  @Input()
  set filterMode(value: FilterMode) {
    if (value === this._filterMode) return;
    this._filterMode = value;
    this.load();
  }
  private _filterService: ListFilterService;
  get filterService(): ListFilterService {
    return this._filterService;
  }
  @Input()
  set filterService(value: ListFilterService) {
    if (value === this._filterService) return;
    this._filterService = value;
    this.load();
  }
  @Output() filterChanged = new EventEmitter();

  private steps: CustomStepDefinition[];
  private _selectedStepIndex = 0;
  get selectedStepIndex(): number {
    return this._selectedStepIndex;
  }

  set selectedStepIndex(value: number) {
    if (this._selectedStepIndex === value) return;
    this._selectedStepIndex = value;
    if (!this.steps) return;
    const step = this.steps[value];
    const bag = this._property.DataBag as DateDataBag;
    bag.From = step.fromDate;
    bag.To = step.toDate;
    this.setDescriptionAndTitle();
    this._property.IsFiltered = this._selectedStepIndex !== 0;
    this.filterChanged.emit();
  }

  get isFooterVisible(): boolean {
    return this.filterMode === 'FilterBy' || this.filterMode === 'SeeAll';
  }

  get isResetSliderVisible(): boolean {
    return this.sliderOptions && this.sliderOptions.disabled;
  }

  sliderOptions: SliderOptions = {
    showSelectionBarEnd: true
  };

  // get title(): string {
  //   const bag = this._property?.DataBag as DateDataBag;
  //   if (!bag) return undefined;
  //   const selectedOptionCount = this.getSelectedOptionCount();
  //   if (this.filterMode === 'MultipleProperties') {
  //     if (bag.Mode === DateFilterMode.SpecificDates) {
  //       if (selectedOptionCount) {
  //         return `${this._property.DisplayName} (${selectedOptionCount})`;
  //       }
  //       else {
  //         return this._property.DisplayName;
  //       }
  //     }
  //     return this.sliderTitle;
  //   }
  //   else {
  //     if (selectedOptionCount) {
  //       return `Filter by '${this.property.DisplayName}' (${selectedOptionCount})`;
  //     }
  //     else {
  //       return `Filter by '${this.property.DisplayName}'`;
  //     }
  //   }
  // }

  get title(): string {
    const bag = this._property?.DataBag as DateDataBag;
    if (!bag) return undefined;

    if (this.filterMode === 'MultipleProperties') {
      if (this.isSpecificDatesMode(bag.Mode)) {
          return this._property.DisplayName;
      }
      return this.sliderTitle;
    }
    else {
        return `Filter by '${this.property.DisplayName}'`;
    }
  }
  isSpecificDatesMode(mode:DateFilterMode): boolean{
    return mode === DateFilterMode.SpecificDates;
  }
  get isSideBar(): boolean {
    return this._filterMode === 'FilterBy' || this._filterMode === 'SeeAll';
  }

  get isSliderVisible(): boolean {
    return this.sliderOptions && this._filterMode === 'MultipleProperties';
  }

  get firstStepLeyend(): string {
    if (this.items && this.items.length && this.steps) return this.steps[0]?.legend;
    return undefined;
  }

  get lastStepLeyend(): string {
    if (this.items && this.items.length && this.steps) return this.steps[this.steps.length - 1]?.legend
    return undefined;
  }

  get sliderTitle() {
    if (this._property) {
      const description = this.items && this.items.length && this.steps && this.steps[this.selectedStepIndex].description;
      if (description) return `${this._property.DisplayName} ${description}`;
      else return this._property.DisplayName;
    }
    return undefined;
  }

  get isSeeAllVisible(): boolean {
    return this.filterMode === 'MultipleProperties' &&
      this.allOptionCount > visibleOptionCount;
  }

  visibleOptions: Option[] = [];
  options: Option[] = [];

  private filterPropertyChangedSubscription: Subscription;
  private filterClearedSubscription: Subscription;

  constructor(
    public sidebar: SideBarService,
    private datePipe: DatePipe,
    private eventBroker: EventBrokerService) {

      this.filterPropertyChangedSubscription = eventBroker.subscribe(
        'FilterPropertyChanged', this.filterPropertyChangedHandler);

      this.filterClearedSubscription = eventBroker.subscribe(
        'FilterCleared', this.filterClearedHandler
      );
  }

  ngOnDestroy() {
    console.log("string filter destroyed");
    if (this.filterPropertyChangedSubscription) this.filterPropertyChangedSubscription.unsubscribe();
    if (this.filterClearedSubscription) this.filterClearedSubscription.unsubscribe();
  }

  private filterPropertyChangedHandler = (e: FilterPropertyChanged) => {
    if (e.sender === this || this._property !== e.property) return;
    this.load();
  }

  // private getSelectedOptionCount() {
  //   let count = 0;
  //   for (const op of this.options) {
  //     if (op.IsChecked) count++;
  //   }
  //   return count;
  // }

  get selectedOptionCount() {
    let count = 0;
    for (const op of this.options) {
      if (op.IsChecked) count++;
    }
    return count;
  }

  private filterClearedHandler = (filterService: ListFilterService) => {
    if (filterService !== this.filterService) return;
    this.load();
  }

  ngOnInit(): void {
    this.load();
  }

  private getItems(): any[] {
    if (this.filterMode === 'FilterBy') {
      return this.filterService.getFiltedItems(this.property)
    }
    return this.filterService.items;
  }

  load() {
    if (!this._filterService || !this._property || !this._filterMode) {
      this.items = [];
      this.options = [];
      this.visibleOptions = [];
      return;
    }
    this.items = this.getItems();
    this.setDateLimits();
    this.loadSliderOptions();
    this.loadOptions();
  }

  private getRoundedDate(item: any): Date {
    const d = new Date(getValue(item, this.propertyPath, false));
    return d ? new Date(d.getFullYear(), d.getMonth(), d.getDate()) : null;
  }

  private getAllOptions(): Option[] {
    const allValues =  iterableMap(this.items, item => this.getRoundedDate(item));
    const allDistinctValues = distinctDates(allValues);
    return allDistinctValues.map(d => {
      if (d) {
        return {
          DisplayName: this.datePipe.transform(d),
          Value: d,
          IsChecked: false,
          Id: newId()
        };
      }
      return {
        DisplayName: '(no metadata tag)',
        Value: null,
        IsChecked: false,
        Id: newId()
      };
    });
  }

  private getOptionsWithNewIds(options: Option[]): Option[] {
    const result: Option[] = [];
    options.forEach(x => {
      const op = Object.assign({}, x);
      op.Id = newId();
      result.push(op);
    });
    return result;
  }


  private loadOptions() {
    const allOptions = this.getAllOptions();
    this.allOptionCount = allOptions.length;
    const allOptionByTime = new Map<number, Option>();
    for (const option of allOptions) allOptionByTime.set(option.Value ? (option.Value as Date).getTime() : null, option);
    const dataBag = this.property.DataBag as DateDataBag;
    for (const selectedOption of dataBag.SelectedOptions) {
      console.log('selectedOption',selectedOption);
      const op = allOptionByTime.get(selectedOption.Value ? (selectedOption.Value as Date).getTime(): null);
      if (op) op.IsChecked = true;
    }
    switch (this.filterMode) {
      case 'MultipleProperties':
        this.setMultiplePropertiesOptions();
        break;
      case 'FilterBy':
        this.setFilterByOptions(allOptions, allOptionByTime);
        break;
      case 'SeeAll':
        this.setSeeAllOptions(allOptions);
    }
  }

  equalOptionsValue(op1: Option, op2: Option): boolean {
    return this.equalDates(op1.Value as Date, op2.Value as Date)
  }

  equalDates(d1: Date, d2: Date): boolean {
    if (d1 === d2) return true;
    if (d1 === null || d2 === null) return false;
    return d1.getTime() === d2.getTime();
  }

  private setSeeAllOptions(allOptions: Option[]) {
    const dataBag = this.property.DataBag as DateDataBag;
    const preferredOptions = this.getOptionsWithNewIds(dataBag.SelectedOptions
      .concat(dataBag.SelectedOptionsHistory));
    const nonPreferedOptions = allOptions.filter(
      op => preferredOptions.findIndex((po) => this.equalOptionsValue(op, po)) < 0);
    this.options = preferredOptions.concat(nonPreferedOptions);
    this.visibleOptions = this.options;
  }

  private setFilterByOptions(allOptions: Option[], allOptionByValue: Map<number, Option> ) {
    const dataBag = this.property.DataBag as DateDataBag;
    const preferredOptions = this.getOptionsWithNewIds(dataBag.SelectedOptions
      .concat(dataBag.SelectedOptionsHistory
      .filter(oph => allOptionByValue.has(oph.Value ? (oph.Value as Date).getTime() : null))));
    const nonPreferedOptions = allOptions.filter(
      op => preferredOptions.findIndex(po => this.equalOptionsValue(op, po)) < 0);
    this.options = preferredOptions.concat(nonPreferedOptions);
    this.visibleOptions = this.options;
  }

  private setMultiplePropertiesOptions() {
    const dataBag = this.property.DataBag as DateDataBag;
    const preferredOptions = this.getOptionsWithNewIds(dataBag.SelectedOptions
      .concat(dataBag.SelectedOptionsHistory));
    this.options = preferredOptions;
    this.visibleOptions = preferredOptions.slice(0, visibleOptionCount);
  }

  private loadSliderOptions() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
    const steps: CustomStepDefinition[] = [];
    steps.push({
      value: today.getTime(),
      legend: 'Today',
      description: 'today',
      fromDate: today,
      toDate: undefined
    } as CustomStepDefinition);
    const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    if (this.minDate < today) {
      steps.push({
        value: yesterday.getTime(),
        legend: 'Yesterday',
        description: 'since yesterday',
        fromDate: yesterday,
        toDate: undefined
      } as CustomStepDefinition);
    }
    const lastSevenDays =  new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
    if (this.minDate < yesterday) {
      steps.push({
        value: lastSevenDays.getTime(),
        legend: "Last 7 days",
        description: "in last 7 days",
        fromDate: lastSevenDays,
        toDate: undefined
      } as CustomStepDefinition);
    }
    const lastThirtyDays = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30);
    if (this.minDate < lastSevenDays) {
      steps.push({
        value: lastThirtyDays.getTime(),
        legend: "Last 30 days",
        description: "in last 30 days",
        fromDate: lastThirtyDays,
        toDate: undefined
      } as CustomStepDefinition);
    }

    const lastThreeMonths =  new Date(today.getFullYear(), today.getMonth() -3, today.getDate());
    if (this.minDate < lastThirtyDays) {
      steps.push({
        value: lastThreeMonths.getTime(),
        legend: "Last 3 months",
        description: "in last 3 months",
        fromDate: lastThreeMonths,
        toDate: undefined
      } as CustomStepDefinition);
    }

    const thisYear = today.getFullYear();
    const sinceThisYear = new Date(thisYear, 0, 1)
    if (this.minDate < lastThreeMonths && sinceThisYear < lastThreeMonths)
    {
      steps.push({
        value: sinceThisYear.getTime(),
        legend: `${thisYear}`,
        description: `since ${thisYear}`,
        fromDate: sinceThisYear,
        toDate: undefined
      });
    }

    const lastYear = today.getFullYear() - 1;
    const sinceLastYear = new Date(lastYear, 0, 1);
    if (this.minDate < sinceThisYear && this.minDate < lastThreeMonths) {
      steps.push({
        value: sinceLastYear.getTime(),
        legend: `${lastYear}`,
        description: `since ${lastYear}`,
        fromDate: sinceLastYear,
        toDate: undefined
      });
    }

    const fiveYear = today.getFullYear() - 5;
    const sinceFiveYears = new Date(fiveYear, 0, 1);
    if (this.minDate < sinceLastYear) {
      steps.push({
        value: sinceFiveYears.getTime(),
        legend: `${fiveYear}`,
        description: `since ${fiveYear}`,
        fromDate: sinceFiveYears,
        toDate: undefined
      });
    }

    const tenYear = today.getFullYear() - 10;
    const sinceTenYears = new Date(tenYear, 0, 1);
    if (this.minDate < sinceFiveYears) {
      steps.push({
        value: sinceTenYears.getTime(),
        legend: `${tenYear}`,
        description: `since ${tenYear}`,
        fromDate: sinceTenYears,
        toDate: undefined
      });
    }

    if (this.minDate < sinceTenYears || this.isThereEmptyDates) {
      steps.push({
        value: 0,
        legend: 'Since ever',
        description: 'since ever',
        fromDate: undefined,
        toDate: undefined
      });
    }
    steps.reverse();

    if (this.maxDate > today) {
      steps.push({
        value: 0,
        legend: 'Tomorrow',
        description: 'tomorrow',
        fromDate: tomorrow,
        toDate: undefined
      });
    }

    const inSevenDays = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7);
    if (this.maxDate > tomorrow) {
      steps.push({
        value: 0,
        legend: 'In 7 days',
        description: 'in 7 days',
        fromDate: inSevenDays,
        toDate: undefined
      });
    }

    const in30Days = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 30);
    if (this.maxDate > inSevenDays) {
      steps.push({
        value: 0,
        legend: 'In 30 days',
        description: 'in 30 days',
        fromDate: in30Days,
        toDate: undefined
      });
    }

    const in3Months = new Date(today.getFullYear(), today.getMonth() + 3, today.getDate());
    if (this.maxDate > in30Days) {
      steps.push({
        value: 0,
        legend: 'In 30 days',
        description: 'in 30 days',
        fromDate: in3Months,
        toDate: undefined
      });
    }

    const nextYear =  today.getFullYear() + 1;
    const inOneYear = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate())
    if (this.maxDate > in3Months) {
      steps.push({
        value: 0,
        legend: `${nextYear}+`,
        description: 'in a year or more',
        fromDate: inOneYear,
        toDate: undefined
      });
    }

    const sliderOptions: SliderOptions = {
      floor: 0,
      ceil: steps.length - 1,
      step: 1,
      showTicksValues: false,
      showSelectionBarEnd: true,
      translate: () => '',
    };
    this.steps = steps;
    const bag = this._property.DataBag as DateDataBag;
    if (bag.Mode === DateFilterMode.SpecificDates) {
      sliderOptions.disabled = true;
    }
    this.sliderOptions = sliderOptions;
    if (!bag.From) {
      this._selectedStepIndex = 0;
    }
    else {
      this._selectedStepIndex = steps.findIndex(s => this.equalDates(s.fromDate, bag.From));
    }
  }

  setDateLimits() {
    let minDate: Date;
    let maxDate: Date;
    for (const item of this.items) {
      const date = getValue(item, this.propertyPath, false) as Date;
      if (date) {
        if (!minDate || date < minDate) minDate = new Date(date);
        if (!maxDate || date > maxDate) maxDate = new Date(date);
      }
      else {
        this.isThereEmptyDates = true;
      }
    }
    this.minDate = minDate && new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate());
    this.maxDate = maxDate && new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate());
  }

  private setDescriptionAndTitle() {
    const bag = this.property.DataBag as DateDataBag;
    switch (bag.Mode) {
      case DateFilterMode.Slider:
        if (this.steps && this._selectedStepIndex !== 0) {
          const step = this.steps[this._selectedStepIndex];
          this._property.Description = `Filtered ${step.description}`;
          this._property.Title = 'Filtered by (1)';
        }
        else {
          this.property.Description = undefined;
          this.property.Title = 'Filter by';
        }
        break;
      case DateFilterMode.SpecificDates:
        if (bag.SelectedOptions && bag.SelectedOptions.length > 0) {
          const selectedDisplayNames = bag.SelectedOptions.map(x => x.DisplayName);
          this.property.Description = `Filtered by ${selectedDisplayNames.join('; ')}` ;
          this.property.Title = `Filter by (${selectedDisplayNames.length})`;
        }
        else {
          this.property.Description = undefined;
          this.property.Title = 'Filter by';
        }
        break;
    }
  }

  seeAll() {
    this.eventBroker.publish('SeeAll', this.property);
  }

  private removeOption(option: Option): void {
    const bag = this.property.DataBag as DateDataBag;
    const selectedIndex = bag.SelectedOptions.findIndex(x => this.equalOptionsValue(x, option));
    if (selectedIndex < 0) return;
    bag.SelectedOptions.splice(selectedIndex, 1);
    this._property.IsFiltered = bag.SelectedOptions.length !== 0;
    bag.SelectedOptionsHistory.push(option);
  }

  /** Add the option to SelectedOption if it is not already there and removes it from history */
  private addOption(option: Option): void {
    const bag = this.property.DataBag as DateDataBag;
    const selectedIndex = bag.SelectedOptions.findIndex(x => this.equalOptionsValue(x, option));
    if (selectedIndex >= 0) return;
    bag.SelectedOptions.push(option);
    this._property.IsFiltered = true;
    const historyIndex = bag.SelectedOptionsHistory.findIndex(x => this.equalOptionsValue(x, option));
    if (historyIndex >= 0) bag.SelectedOptionsHistory.splice(historyIndex, 1);
  }

  private updateOption(option: Option): void {
    if (option.IsChecked) {
      this.addOption(option);
    }
    else {
      this.removeOption(option);
    }
  }

  private enableSlider() {
    if (this.sliderOptions.disabled) {
       const sliderOptions = Object.assign({}, this.sliderOptions);
       sliderOptions.disabled = false;
       this.sliderOptions = sliderOptions;
    }
    if (this._property) {
      const bag = this._property.DataBag as DateDataBag;
      bag.Mode = DateFilterMode.Slider;
      this._property.IsFiltered = this._selectedStepIndex !== 0;
    }
  }

  private disableSlider() {
    if (!this.sliderOptions.disabled) {
       const sliderOptions = Object.assign({}, this.sliderOptions);
       sliderOptions.disabled = true;
       this.sliderOptions = sliderOptions;
    }
    if (this._property) {
      const bag = this._property.DataBag as DateDataBag;
      bag.Mode = DateFilterMode.SpecificDates;
    }
  }

  checkboxChanged(option: Option): void {
    if (this.filterMode ==='MultipleProperties') {
      this.updateOption(option);
      const selectedOptionCount = this.selectedOptionCount;
      if (selectedOptionCount) {
        this.disableSlider();
      }
      else {
        this.enableSlider();
      }
      this.setDescriptionAndTitle();
      this.filterChanged.emit();
    }
  }

  apply(): void {
    for (const option of this.visibleOptions) {
      this.updateOption(option);
    }
    const bag = this._property.DataBag as DateDataBag;
    bag.Mode = this.selectedOptionCount ? DateFilterMode.SpecificDates : DateFilterMode.Slider;
    this.setDescriptionAndTitle();
    this.eventBroker.publish('FilterPropertyChanged', {
      sender: this,
      property: this.property
    } as FilterPropertyChanged)

    this.filterChanged.emit();
    this.sidebar.hide();
  }

  clear(): void {
    for (const op of this.visibleOptions) {
      op.IsChecked = false;
    }
  }

  reset(): void {
    for (const op of this.visibleOptions) {
      op.IsChecked = false;
    }
    for (const op of this.options) {
      op.IsChecked = false;
      this.updateOption(op);
    }
    this.enableSlider();
    if (this.selectedStepIndex === 0) {
      this.filterChanged.emit();
    }
    else {
      this.selectedStepIndex = 0;
    }
    this._property.IsFiltered = false;
    this.setDescriptionAndTitle();
  }
}
